import { InternalToolsIcon } from "components/Svg/ViewSelectorDrawerIcons";
import ListItem from "frontier/lib/components/List/ListItem";
import { ListItemText } from "frontier/lib/components/List/ListItemText";
import ListItemIcon from "frontier/lib/components/List/ListItemIcon";
import { Icons } from "@madhive/kit-ui";
import { css } from "@emotion/react";
import { FC } from "react";
import { style } from "./ViewSelectorDrawer";

const styles = {
  label: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
  `
};

/**
 * Internal Tools entry that navigates off-app to an absolute URL, opening in
 * a new tab. Sibling to InternalViewLink, which instead routes internally via
 * react-router's Link — that component can't target an absolute URL.
 */
const ExternalToolLink: FC<{
  href: string;
  text: string;
  onClick: () => void;
  id: string;
}> = ({ href, text, onClick, id }) => (
  <a
    id={id}
    data-testid={id}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    css={style.linkText}
    onClick={onClick}
  >
    <ListItem button tabIndex={-1} css={style.listContainer()}>
      <ListItemIcon css={style.listItemIcon}>
        <Icons.Display size="medium" fill="var(--color-secondary)">
          <InternalToolsIcon />
        </Icons.Display>
      </ListItemIcon>
      <ListItemText
        value={
          <span css={styles.label}>
            {text}
            <Icons.Display size="extra-small" fill="var(--color-secondary)">
              <Icons.ExternalLink />
            </Icons.Display>
          </span>
        }
      />
    </ListItem>
  </a>
);

export default ExternalToolLink;
